export const AUTHENTICATION_FAILED = "Your authentication attempt was not successful. Please verify your login information and attempt again";
export const PROCESSING_MESSAGE = "Please wait. We're processing your request...";
export const PROFILE_ISSUE = "There was an issue fetching your user profile. Please check your internet connection and try again."
export const UNKNOWN_MESSAGE = 'Unknown message';
export const AUTHENTICATION_IN_PROGRESS = 'Authentication in progress. Please wait...';
export const LOGIN_SUCCESS = "You've successfully logged in.";
export const REDIRECT = "Redirecting to the desired page. Please wait...";
export const LOGOUT = "Logging out of your account. Please wait..."; 
